export default __webpack_public_path__ + "static/full_logo-5f3f88eb0d12377e9918ef2a175ff2e9.png";